import { HAS_FIXED_DEPOSIT_ACCOUNT, HAS_INVESTMENT_PRODUCT_ACCOUNT, HAS_NOTICE_DEPOSIT_ACCOUNT, HAS_OVERNIGHT_DEPOSIT_ACCOUNT, hasEtfConfiguratorProducts, hasPPProducts, } from '@raisin/cp-utils';
import { PRODUCT_CATEGORIES } from '@raisin/investments-data/api/pia_v2/types';
import { EXTERNAL_DOMAINS_REGEX } from '../../constants';
export const hasOrderedProducts = (productAccess, pensionProductsData) => {
    const hasFixedTermAccount = productAccess === null || productAccess === void 0 ? void 0 : productAccess.includes(HAS_FIXED_DEPOSIT_ACCOUNT);
    const hasOvernightAccount = productAccess === null || productAccess === void 0 ? void 0 : productAccess.includes(HAS_OVERNIGHT_DEPOSIT_ACCOUNT);
    const hasNoticeAccount = productAccess === null || productAccess === void 0 ? void 0 : productAccess.includes(HAS_NOTICE_DEPOSIT_ACCOUNT);
    const hasIPPortfolio = productAccess === null || productAccess === void 0 ? void 0 : productAccess.includes(HAS_INVESTMENT_PRODUCT_ACCOUNT);
    const hasPPPortfolio = hasPPProducts(pensionProductsData);
    const hasETFConfigurator = hasEtfConfiguratorProducts(pensionProductsData);
    return (hasFixedTermAccount ||
        hasOvernightAccount ||
        hasNoticeAccount ||
        hasIPPortfolio ||
        hasPPPortfolio ||
        hasETFConfigurator);
};
export const isProductTypePE = (pia) => { var _a; return (_a = pia === null || pia === void 0 ? void 0 : pia.product_instances) === null || _a === void 0 ? void 0 : _a.some((p) => p.product_category === PRODUCT_CATEGORIES.ILLIQUID); };
export const hasCryptoPortfolio = (pensionProducts) => { var _a; return !!((_a = pensionProducts === null || pensionProducts === void 0 ? void 0 : pensionProducts.products) === null || _a === void 0 ? void 0 : _a.some((product) => product.type === 'crypto')); };
export const resolveUrlWithLocale = (url, localeBasePath) => {
    if (!url) {
        return '';
    }
    const currentURL = url.toLowerCase();
    if (EXTERNAL_DOMAINS_REGEX.test(currentURL)) {
        return currentURL;
    }
    const urlWithoutBasePath = currentURL.replace(localeBasePath, '');
    return `${localeBasePath}${urlWithoutBasePath}`;
};
//# sourceMappingURL=index.js.map